import { motion } from "framer-motion";
import { CheckIcon } from "lucide-react";

import { springSnappy } from "./constants";

export const SuccessCheckmark = () => (
  <motion.div
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ ...springSnappy, delay: 0.05 }}
    className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-emerald-50 dark:bg-emerald-500/10"
  >
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ ...springSnappy, delay: 0.12 }}
    >
      <CheckIcon className="h-6 w-6 text-emerald-500" strokeWidth={2.5} />
    </motion.div>
  </motion.div>
);
